// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__B24rO","total":"Cart_total__m+OWY","actions":"Cart_actions__F9Zb4","button--alt":"Cart_button--alt__C0de0","button":"Cart_button__B3Th4"};